import React from 'react';
import useProjectDefinition from 'src/app/projects/views/new-project-definition/hooks/useProjectDefinition';
import HabitatInsightsSamplesReviewMap from './components/habitat-insights-samples-review-map/HabitatInsightsSamplesReviewMap';
import HabitatInsightsSampleSidebar from './components/habitat-insights-samples-sidebar/HabitatInsightsSamplesSidebar';
import styles from './HabitatInsightsReview.module.scss';

const HabitatInsightsReview = () => {
    const { formState } = useProjectDefinition();
    const { habitatInsightsSites } = formState;

    return (
        <div className={styles.reviewAndSubmit}>
            <div className={styles.container}>
                <div className={styles.mainContent}>
                    <HabitatInsightsSamplesReviewMap data={habitatInsightsSites} />
                </div>
                <div className={styles.sidebar}>
                    <HabitatInsightsSampleSidebar data={habitatInsightsSites} />
                </div>
            </div>
        </div>
    );
};

export default HabitatInsightsReview;
